import { Form } from 'react-bootstrap';
import { useFieldArray, Controller } from "react-hook-form";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import classNames from "classnames";

// Custom Component
import ErrorText from '../../TextField/ErrorText';

// Utils
import { isSingleEvent, isDoubleEvent, isMixedEvent, isAgeValueRequired, getMinGenderParticipants, getMaxGenderParticipants } from '../../../utils/helper';

const TeamAgeGroup = ({ teamIndex, nestIndex, allWatchedValues, control, register, errors, tournament }) => {
    const { fields, remove, append } = useFieldArray({
        control,
        name: `team_events[${teamIndex}].event_details[${nestIndex}].age_groups`
    });

    return <div>
        {fields?.length > 0 && fields.map((item, index) => {
            return <div>
                <div className='d-flex flex-column align-items-start mt-4 position-relative' key={item.id}>
                    <div className='d-flex align-items-start w-100 pe-4'>
                        <div className='d-flex flex-column align-items-start flex-grow-1'>
                            <div className={classNames("w-100 d-flex flex-column flex-sm-row align-items-start pe-2", {
                                'mb-3': isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type)
                            })}>
                                <div className={classNames('w-50 w-xs-100 me-2', {
                                    'me-xs-0': !isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type)
                                })}>
                                    <Form.Group>
                                        <Form.Label className='fs-14 fw-500'>Age group</Form.Label>
                                        <Form.Select
                                            {...register(`team_events[${teamIndex}].event_details[${nestIndex}].age_groups[${index}].age_group`, {
                                                required: "Age Group is required"
                                            })}
                                            disabled={!allWatchedValues?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.is_disabled}
                                        >
                                            <option value="BELOW_AGE">Below age</option>
                                            <option value="ABOVE_AGE">Above age</option>
                                            {!(isSingleEvent(allWatchedValues?.team_events[teamIndex]?.event_type)) && <option value="TOTAL_BELOW_AGE">Total below age</option>}
                                            {!(isSingleEvent(allWatchedValues?.team_events[teamIndex]?.event_type)) && <option value="TOTAL_ABOVE_AGE">Total above age</option>}
                                            <option value="OPEN">Open</option>
                                            <option value="AMATEUR">Amateur</option>
                                            {isDoubleEvent(allWatchedValues?.team_events[teamIndex]?.event_type) && <option value="SEMI_PRO">Semi-Pro</option>}
                                            <option value="BAKAT_BARU">Bakat Baru</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                {isAgeValueRequired(allWatchedValues?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.age_group) &&
                                    <div className='w-50 w-xs-100 mt-3 mt-sm-0'>
                                        <Form.Group>
                                            <Form.Label className='fs-14 fw-500'>Value of Age</Form.Label>
                                            <Controller
                                                control={control}
                                                name={`team_events[${teamIndex}].event_details[${nestIndex}].age_groups[${index}].age_value`}
                                                render={({ field }) => {
                                                    return (
                                                        <Form.Control
                                                            type="number"
                                                            {...field}
                                                            onChange={(e) => field.onChange(parseInt(e.target.value))}
                                                        />
                                                    )
                                                }}
                                                rules={{
                                                    required: "Age Value is required"
                                                }}
                                            />
                                            {errors?.team_events?.length >= teamIndex && errors?.team_events[teamIndex]?.event_details?.length >= nestIndex && errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups?.length >= index && errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.age_value && <ErrorText>{errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.age_value?.message}</ErrorText>}
                                        </Form.Group>
                                    </div>
                                }
                            </div>
                            <div className="d-flex flex-column flex-sm-row align-items-start w-100 pe-2">
                                <div className={classNames({
                                    'w-50 w-xs-100 me-2': isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type),
                                    'd-none': !isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type)
                                })}>
                                    <Form.Group>
                                        <Form.Label className='fs-14 fw-500'>Number of Male</Form.Label>
                                        <Form.Control
                                            type="number"
                                            {...register(`team_events[${teamIndex}].event_details[${nestIndex}].age_groups[${index}].number_of_males`, {
                                                required: isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type) ? "Number of Male is required" : false,
                                                ...(getMaxGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type) > 0
                                                    ? {
                                                        max: {
                                                            value: getMaxGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type),
                                                            message: `You can't add more than ${getMaxGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type)} male`
                                                        }
                                                    }
                                                    :
                                                    {}
                                                ),
                                                min: {
                                                    value: getMinGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type),
                                                    message: `You need to add at least ${getMinGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type)} male`
                                                }
                                            })}
                                            disabled={!allWatchedValues?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.is_disabled}
                                        />
                                        {errors?.team_events?.length >= teamIndex && errors?.team_events[teamIndex]?.event_details?.length >= nestIndex && errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups?.length >= index && errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.number_of_males && <ErrorText>{errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.number_of_males?.message}</ErrorText>}
                                    </Form.Group>
                                </div>
                                <div className={classNames({
                                    'w-50 w-xs-100 mt-3 mt-sm-0': isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type),
                                    'd-none': !isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type)
                                })}>
                                    <Form.Group>
                                        <Form.Label className='fs-14 fw-500'>Number of Female</Form.Label>
                                        <Form.Control
                                            type="number"
                                            {...register(`team_events[${teamIndex}].event_details[${nestIndex}].age_groups[${index}].number_of_females`, {
                                                required: isMixedEvent(allWatchedValues?.team_events[teamIndex]?.event_type) ? "Number of Female is required" : false,
                                                ...(getMaxGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type) > 0
                                                    ? {
                                                        max: {
                                                            value: getMaxGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type),
                                                            message: `You can't add more than ${getMaxGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type)} female`
                                                        }
                                                    }
                                                    :
                                                    {}
                                                ),
                                                min: {
                                                    value: getMinGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type),
                                                    message: `You need to add at least ${getMinGenderParticipants(allWatchedValues?.team_events[teamIndex]?.event_type)} female`
                                                }
                                            })}
                                            disabled={!allWatchedValues?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.is_disabled}
                                        />
                                        {errors?.team_events?.length >= teamIndex && errors?.team_events[teamIndex]?.event_details?.length >= nestIndex && errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups?.length >= index && errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.number_of_females && <ErrorText>{errors?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.number_of_females?.message}</ErrorText>}
                                    </Form.Group>
                                </div>
                            </div>
                        </div>
                        <Form.Group className='d-flex flex-column align-items-end'>
                            <Form.Check
                                type="switch"
                                className='age-group-switch'
                                {...register(`team_events[${teamIndex}].event_details[${nestIndex}].age_groups[${index}].is_disabled`)}
                            />
                            <Form.Label className='fs-14 fw-500'>{allWatchedValues?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.is_disabled ? "Enable" : "Disable"}</Form.Label>
                        </Form.Group>
                    </div>

                    {fields.length > 1 && <IoMdClose role='button' className='position-absolute top-0 end-0' color='red' size={20} onClick={() => remove(index)} />}
                </div>
                <Form.Check
                    type='checkbox'
                    className='mt-2'
                    label={<span role='button' className='fw-500 text-secondary'>
                        Allow State/District/National Player to join?
                    </span>}
                    id={`allow-join[${teamIndex}][${nestIndex}][${index}`}
                    required={isDoubleEvent(allWatchedValues?.team_events[teamIndex]?.event_type) && (allWatchedValues?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.age_group === "SEMI_PRO")}
                    {...register(`team_events[${teamIndex}].event_details[${nestIndex}].age_groups[${index}].allow_proffesional_players`)}
                    disabled={!allWatchedValues?.team_events[teamIndex]?.event_details[nestIndex]?.age_groups[index]?.is_disabled}
                />
            </div>
        })}

        <div role='button' className='d-inline-flex align-items-center mt-4' onClick={() =>
            append({
                age_group: "BELOW_AGE",
                age_value: "",
                number_of_males: "",
                number_of_females: "",
                is_disabled: true,
                allow_proffesional_players: false
            })
        }>
            <BsFillPlusCircleFill className='text-primary me-2' size={25} />
            <span className='text-primary fw-500'>Add more age group</span>
        </div>
    </div>
};

export default TeamAgeGroup;